import React, { useEffect } from "react";
import "../styles/home.css";
import { motion } from "framer-motion";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import logo from "../assets/shanna-logo1.jpg";
import ServiciosCarrusel from "../components/ServiciosCarrusel";
import Galeria from "../components/Galeria";

const Home = () => {
  // 🏷️ Cambiamos el título del navegador
  useEffect(() => {
    document.title = "Shanna Biopeluqueria";
  }, []);

  return (
    <main className="home-container">
      {/* 🌸 HERO */}
      <section className="hero">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Bienvenida a <span>Shanna Biopeluquería</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Tu belleza natural, cuidada con amor y productos conscientes.
        </motion.p>

        <motion.a
          href="/turnos"
          className="hero-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
        >
          Reservar turno
        </motion.a>
      </section>

      {/* 💇‍♀️ SECCIÓN DE SERVICIOS */}
      <section className="servicios-section">
        <h2 className="titulo-servicios">Nuestros Servicios</h2>
        <p className="descripcion-servicios">
          Descubrí los tratamientos que realzarán tu belleza natural con técnicas saludables.
        </p>

        <ServiciosCarrusel />

        <div className="boton-servicios-container">
          <a href="/services" className="boton-servicios">
            Ver todos los servicios
          </a>
        </div>
      </section>

      {/* 🌿 QUIÉNES SOMOS */}
      <section className="about">
        <div className="about-text">
          <h2>Quiénes Somos</h2>
          <p>
            En <strong>Shanna Biopeluquería</strong> creemos que cada cabello cuenta su propia historia.
            Usamos productos naturales y técnicas conscientes para resaltar tu belleza sin comprometer tu salud ni la del planeta.
          </p>
          <p>
            Nos dedicamos a crear un espacio donde puedas relajarte, renovarte y sentirte en armonía contigo misma.
          </p>
        </div>

        <div className="about-image">
          <img src={logo} alt="Shanna Biopeluquería" />
        </div>
      </section>

      {/* 🌷 GALERÍA */}
      <section className="galeria-section">
        <Galeria />
        <div className="galeria-boton-container">
        
        </div>
      </section>

      {/* 📅 TURNOS */}
      <section className="turnos-home-section">
        <div className="turnos-content">
          <div className="turnos-titulo-container">
            <h2 className="turnos-titulo-elegante">Reservá tu turno</h2>
            <div className="linea-dorada-turnos"></div>
          </div>

          <p className="turnos-descripcion">
            Elegí el servicio que más te guste y encontrá el momento ideal para vos.
            Gestionamos cada turno de forma personalizada para brindarte una experiencia única y relajante.
          </p>

          <a href="/turnos" className="turnos-boton">
            Reservar ahora
          </a>
        </div>
      </section>

      {/* 🌸 REDES SOCIALES */}
      <section className="redes-section">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-3xl font-playfair text-[#3F342F] mb-4 text-center"
        >
          Conectá con <span className="text-[#b08b76]">Shanna</span> 🌸
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="mb-10 max-w-xl mx-auto text-[#3F342F]/80"
        >
          Seguinos en nuestras redes para descubrir nuevos estilos, consejos y el día a día de{" "}
          <strong>Shanna Biopeluquería</strong>.
        </motion.p>

        <div className="flex justify-center gap-10 mb-10">
          {[
            { icon: <FaInstagram />, href: "https://www.instagram.com/multiespacio.shanna" },
            { icon: <FaFacebookF />, href: "https://www.facebook.com/sandranoemi.olivares.9" },
            { icon: <FaWhatsapp />, href: "https://wa.me/5492665041280" },
          ].map((red, i) => (
            <motion.a
              key={i}
              href={red.href}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              whileHover={{ scale: 1.15, rotate: 5 }}
              transition={{ duration: 0.4 }}
              className="text-[#3F342F] hover:text-[#b08b76] text-3xl bg-[#fff] rounded-full p-4 shadow-md transition-all"
            >
              {red.icon}
            </motion.a>
          ))}
        </div>
      </section>

      {/* 🩷 FOOTER */}
      <footer className="footer">
        <p>© 2025 Shanna Biopeluquería — Todos los derechos reservados.</p>
        <p>San Luis, Argentina</p>
      </footer>
    </main>
  );
};

export default Home;
